"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Text = _interopRequireDefault(require("../Text"));
var _Sidebar = _interopRequireDefault(require("./Sidebar.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */

var TabWrapper = _styledComponents.default.div.withConfig({
  displayName: "Sidebar__TabWrapper",
  componentId: "sc-sjpl0h-0"
})(["display:inline-flex;flex-direction:column;overflow:hidden;width:", ";box-shadow:", ";align-items:center;align-content:space between;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '100%' : '100px';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '0px 4px 4px rgba(0, 0, 0, 0.08)' : '0';
});
var FlexColumn = _styledComponents.default.div.withConfig({
  displayName: "Sidebar__FlexColumn",
  componentId: "sc-sjpl0h-1"
})(["display:flex;flex-direction:", ";width:100%;"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'row' : 'column';
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Sidebar__IconWrapper",
  componentId: "sc-sjpl0h-2"
})(["display:flex;align-items:flex-start;justify-content:center;padding:0px 2px 0px 2px;"]);
var border = function border(isActive, theme) {
  return isActive ? "3px solid ".concat(theme.colors.tertiary) : "3px solid ".concat(theme.colors.greyLightest);
};
var TabHead = _styledComponents.default.div.withConfig({
  displayName: "Sidebar__TabHead",
  componentId: "sc-sjpl0h-3"
})(["", ";", ";cursor:pointer;flex:0 1 100%;flexDirection:row;flex-wrap:wrap text-align:center;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:flex;align-items:center;justify-content:center;flex-direction:", ";"], function (_ref4) {
  var isActive = _ref4.isActive,
    theme = _ref4.theme,
    isMobile = _ref4.isMobile;
  return !isMobile ? "border-left: ".concat(border(isActive, theme)) : "border-bottom: ".concat(border(isActive, theme));
}, function (_ref5) {
  var theme = _ref5.theme,
    isMobile = _ref5.isMobile;
  return !isMobile ? "padding: ".concat(theme.space.standard) : "padding: ".concat(theme.space.medium, " ").concat(theme.space.small, "}");
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? 'row' : 'column';
});
var Sidebar = function Sidebar(props) {
  var accessible = props.accessible,
    customProperties = props.customProperties,
    itemList = props.itemList,
    selectedTab = props.selectedTab,
    setSelectedTab = props.setSelectedTab,
    theme = props.theme,
    isMobile = props.isMobile;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var propSelectedTab = typeof selectedTab === 'number' ? selectedTab : 0;
  var tabIndex = !accessible ? '-1' : '0';
  var _React$useState = _react.default.useState(propSelectedTab),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    activeTab = _React$useState2[0],
    setActiveTab = _React$useState2[1];
  var handleTabClick = function handleTabClick(index) {
    setActiveTab(index);
    if (typeof setSelectedTab === 'function') setSelectedTab(index);
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(TabWrapper, (0, _extends2.default)({}, customProperties, {
      isMobile: isMobile
    }), /*#__PURE__*/_react.default.createElement(FlexColumn, {
      isMobile: isMobile
    }, itemList.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(TabHead, {
        isActive: index === activeTab,
        key: 'label'.concat(index.toString()),
        onClick: function onClick() {
          return handleTabClick(index);
        },
        tabIndex: tabIndex,
        isMobile: isMobile
      }, item.key === _constant.LABEL.hotel ? /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        theme: theme,
        accessible: accessible,
        color: index === activeTab ? _constant.SIDEBAR_ICONS.HotelIcon.ActiveColor : _constant.SIDEBAR_ICONS.HotelIcon.InActiveColor,
        fontsize: _constant.SIDEBAR_ICONS.HotelIcon.size,
        icon: _constant.SIDEBAR_ICONS.HotelIcon.type
      })) : /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        theme: theme,
        accessible: accessible,
        color: index === activeTab ? _constant.SIDEBAR_ICONS.HotelIcon.ActiveColor : _constant.SIDEBAR_ICONS.HotelIcon.InActiveColor,
        fontsize: _constant.SIDEBAR_ICONS.FlightIcon.size,
        icon: _constant.SIDEBAR_ICONS.FlightIcon.type
      })), /*#__PURE__*/_react.default.createElement(_Text.default, {
        theme: theme,
        type: _constant.TEXT_TYPE.default.type,
        marginLeft: isMobile ? _constant.TEXT_TYPE.default.marginLeft : '',
        color: index === activeTab ? _constant.SIDEBAR_ICONS.HotelIcon.ActiveColor : _constant.SIDEBAR_ICONS.HotelIcon.InActiveColor,
        bold: true
      }, item.label));
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Sidebar.propTypes = _Sidebar.default.PropTypes;
Sidebar.defaultProps = _Sidebar.default.DefaultProps;
var _default = Sidebar;
exports.default = _default;